import styled from 'styled-components';
import { device } from '../../../media_queries';

export const MainClientEdit = styled.section`
  width: 70%;
  /* height: 85%; */
  display: flex;
  justify-content: center;
  align-items: center;
  /* padding-top: 80px;*/
  /* margin: auto; */
  /* margin-bottom: 13px;  */
  @media ${device.mobileS} {
    
  }
  @media ${device.tablet} {
    
  }
  @media ${device.laptop} {
    
  }
  @media ${device.desktop} {
    
  }
`;

export const FormClientData = styled.form`
  width: 100%;
  height: auto;
  display: flex;
  flex-wrap: wrap;
  /* flex-direction: column; */
  justify-content: center;
  align-items: center;
  margin: auto;
  @media ${device.mobileS} {
    
  }
  @media ${device.tablet} {
    
  }
  @media ${device.laptop} {
    
  }
  @media ${device.desktop} {
    
  }
`;

export const LabelClientData = styled.label``;